import { EditableType } from '../../constants';

export enum TagName {
	div = 'DIV',
	img = 'IMG',
	video = 'VIDEO',
	iframe = 'IFRAME',
}

export enum VideoParam {
	autoplay = 'autoplay',
	controls = 'controls',
	muted = 'muted',
}

export const youtubeJsApiAttribute = 'enablejsapi';

export type VideoSettings = {
	[key in VideoParam]: boolean;
};

export interface MediaElementSources {
	defaultLink: string;
	driveLink: string;
	externalLink: string | undefined;
	isExternalLinkActive: boolean;
}

export interface MediaElementData extends MediaElementSources {
	type: EditableType;
	// width, height, x and y are stored in px for inDesign editor and in % for HTML editor
	width: number;
	height: number;
	x: number;
	y: number;
	label: string;
	defaultLabel?: string;
	videoSettings?: VideoSettings;
	isEditedFromBackoffice: boolean;
	tooltip: string;
	isTooltipActive: boolean;
	canDragAndResize: boolean;
	isVisible?: boolean;
	isInsideButton?: boolean;
	altAttr?: string;
	originalStyle?: string;
}

export interface MediaElementConfig {
	page: number;
	id: string;
	// this prop is needed for correct file importing (media elements on duplicated pages have same ids but we need to have unique ids to insert imported file to right media element)
	importManagerId: string;
	frameWidth: number;
	frameHeight: number;
	isLoaded: boolean;
}

export type MediaElement = HTMLImageElement | HTMLVideoElement | HTMLSourceElement | HTMLIFrameElement;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableMedia/typing.ts